import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../shared/services/auth.service';
import { Router } from '@angular/router';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { countryReference } from '../../../utils/constants/strings';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  message: 'SignUp';
  signupForm: FormGroup;
  submitted = false;
  listOfCountries = countryReference;
  filterSearchByCountry = countryReference;
  show: boolean = false;
  @ViewChild('search') searchElement: ElementRef;
  customerIDs;
  filterSearchByCustomerIDs;
  productList: any = [{ name: 'BBX' }, { name: 'LBX' }];
  newCustomerForm: FormGroup;
  newOrExisting: string;
  selectNewCustOption: boolean;
  productType = ['BBX', 'LBX'];
  userRegScreenDisplay: boolean = false;
  hideRadio: boolean = false;
  customerRole: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<SignUpComponent>,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private errorDialogService: ErrorDialogService,
    private router: Router
  ) {
    this.message = data.message;
    this.getCustomersToRegister();
  }

  initializingSignUpForm() {
    this.signupForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-z]{2,4}$'),
        ],
      ],
      firstName: ['', [Validators.required, Validators.maxLength(45)]],
      lastName: ['', [Validators.required, Validators.maxLength(45)]],
      customerID: ['', Validators.required],
      timezone: [''],
      country: ['', Validators.required],
      searchTerm: [''],
      searchCustomerID: [''],
      productType: [['BBX', 'LBX'], Validators.required],
    });
  }

  showSearch() {
    this.show = !this.show;
    setTimeout(() => this.searchElement.nativeElement.focus(), 0);
  }

  get f() {
    return this.signupForm.controls;
  }

  signupUser() {
    this.submitted = true;
    if (this.signupForm.valid) {
      const closedialog = 'close';
      sessionStorage.setItem('closedialog', closedialog);
      const userdata = {
        userID: this.signupForm.getRawValue().email,
        firstName: this.signupForm.value.firstName,
        lastName: this.signupForm.value.lastName,
        customerID: this.signupForm.value.customerID,
        timezone: 'GMT' + this.signupForm.value.country.gmt,
        country: this.signupForm.value.country.code,
        productType: this.productList,
      };

      this.authService.signUpUser(userdata).subscribe(res => {
        this.errorDialogService.openDialog(res, false);
        window.location.reload();
        this.router.navigateByUrl('/login');
      });
    }
  }

  filterBySearch() {
    const searchTerm = this.signupForm.value.searchTerm;
    if (searchTerm && searchTerm.trim() !== '') {
      this.listOfCountries = this.filterSearchByCountry.filter(
        item => item?.name?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    } else {
      this.listOfCountries = this.filterSearchByCountry;
    }
  }

  filterBySearchCustomerIds() {
    const searchTerm = this.signupForm.value.searchCustomerID;
    if (searchTerm && searchTerm.trim() !== '') {
      this.customerIDs = this.filterSearchByCustomerIDs.filter(
        item => item?.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    } else {
      this.customerIDs = this.filterSearchByCustomerIDs;
    }
  }

  triggerEvent(event) {
    if (!event) {
      this.listOfCountries = this.filterSearchByCountry;
      this.signupForm.patchValue({ searchTerm: '' });
    }
  }

  triggerCustomerEvent(event) {
    if (!event) {
      this.customerIDs = this.filterSearchByCustomerIDs;
      this.signupForm.patchValue({ searchCustomerID: '' });
    }
  }

  ngOnInit(): void {
    this.initializingNewCustomerForm();
    this.initializingSignUpForm();
    this.customerRole = this.authService.getUserRole();
    const countryCode = this.authService.getUserCountry();
    if (this.customerRole !== 'GLOBAL_ADMIN') {
      this.listOfCountries = this.filterSearchByCountry = this.filterSearchByCountry.filter(
        item => item?.code?.toLowerCase().indexOf(countryCode.toLowerCase()) > -1
      );
    }
  }

  getCustomersToRegister() {
    this.authService.getCustomersByRole().subscribe(res => {
      this.customerIDs = this.filterSearchByCustomerIDs = res.map(customer => customer.customerID);
    //  sessionStorage.setItem('bbx-customerIdArray', JSON.stringify(this.customerIDs));
      if (this.hideRadio) {
        const newCustId = this.customerIDs.find(
          item => item.toLowerCase() == this.newCustomerForm?.value?.customerId.toLowerCase()
        );
        this.signupForm.patchValue({ customerID: newCustId });
      }
    });
  }

  initializingNewCustomerForm() {
    this.newCustomerForm = this.formBuilder.group({
      customerName: ['', Validators.required],
      customerId: ['', Validators.required],
      customerCountry: ['', Validators.required],
      configuration: [true, Validators.required],
      searchTerm: [''],
      productType: [['BBX', 'LBX'], Validators.required],
      cacheActive: [false],
    });
  }

  showHideNewCustomer(e) {
    if (e.value == 'new') {
      this.selectNewCustOption = true;
    } else {
      this.selectNewCustOption = false;
      this.userRegScreenDisplay = true;
    }
  }

  regNewCustomer() {
    if (this.newCustomerForm.valid) {
      const payload = {
        customerID: this.newCustomerForm.value.customerId,
        customerName: this.newCustomerForm.value.customerName,
        country: this.newCustomerForm.value.customerCountry.code,
        product: this.newCustomerForm.value.productType,
        configuration: true,
        timeZone: this.listOfCountries.find(
          item => item.code === this.newCustomerForm.value.customerCountry.code
        )?.gmt,
        cacheActive: this.newCustomerForm.value.cacheActive,
      };
      this.authService.createCustomer(payload).subscribe(response => {
        if (response) {
          this.selectNewCustOption = false;
          this.userRegScreenDisplay = true;
          this.newOrExisting = 'existing';
          this.hideRadio = true;
          this.getCustomersToRegister();
        }
      });
    }
  }
}
